// extracted by mini-css-extract-plugin
module.exports = {"pill":"Reactions_pill","reacted":"Reactions_reacted","reaction":"Reactions_reaction","emoji":"Reactions_emoji","emojis":"Reactions_emojis"};